<template>
  <div>
    <div class="b10">
      <div class="d-ac" v-for="(ac, i) in payAccount" :key="i">
        <p class="ac">{{ ac.account }}</p>
        <a class="a-del" href="javascript:void(0)" @click="delPayAc(ac.id, i)">删除</a>
      </div>
    </div>
    <div>
      <input type="text" class="input" name="payAc" placeholder="填写付款账号" value="" v-model="payAc">
      <span class="btn active" @click="addPayAc">添加付款账号</span>
    </div>
  </div>
</template>

<script>
import '../assets/styles/setting-m.css';
import '../assets/styles/setting.css';

export default {
  data() {
    return {
      payAccount: [],
      payAc: ''
    }
  },
  methods: {
    delPayAc(id, i) {
      var self = this;
      this.$get('/sp/user/pay-account/del', {
        id: id
      }, () => {
        self.payAccount.splice(i, 1)
      })
    },
    addPayAc() {
      if (!this.payAc) {
        this.$msg('付款账号不能为空', 'error');
        return
      }
      var self = this;
      this.$post('/sp/user/pay-account/add', {
        account: this.payAc,
        name: this.user.name
      }, res => {
        self.payAc = '';
        self.payAccount = res;
      })
    },
    loadData() {
      if (!this.user) return;
      const self = this;
      this.$get('/sp/user/pay-account', {username: this.user.name}, res => {
        self.payAccount = res;
      });
    }
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  watch: {
    user() {
      this.loadData()
    }
  },
  mounted() {
    this.loadData()
  }
}
</script>
<style scoped>
[name="payAc"] {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

#pay-account .btn {
  padding: 0px 13px;
  margin-right: 10px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  height: 36px;
  display: inline-block;
  line-height: 36px;
}
</style>
